import { render, staticRenderFns } from "./EditorTagSelect.vue?vue&type=template&id=020f5314&"
import script from "./EditorTagSelect.vue?vue&type=script&lang=ts&"
export * from "./EditorTagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./EditorTagSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports